module.exports = __webpack_public_path__ + "static/media/snack-box.8d764d1e.jpg";